var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "jp-sidebar",
      class: "jp-sidebar--" + _vm.sidebarLayoutSkin,
      style:
        _vm.sidebarLayoutSkin === "5" || _vm.sidebarLayoutSkin === "9"
          ? "background:" + _vm.defaultTheme
          : "",
    },
    [
      _c(
        "div",
        { staticClass: "jp-sidebar__inner" },
        [
          _c(
            "el-menu",
            {
              staticClass: "jp-sidebar__menu",
              attrs: {
                "unique-opened": "",
                "default-active": _vm.menuActiveName || "home",
                collapse: _vm.sidebarFold,
                collapseTransition: false,
              },
            },
            [
              !_vm.sidebarFold
                ? _c("li", { staticClass: "jp-menu-category" }, [
                    _vm._v(_vm._s(_vm.leftMenuCategory)),
                  ])
                : _vm._e(),
              _vm._l(_vm.leftMenuList, function (menu) {
                return _c("sub-menu", {
                  key: menu.id,
                  attrs: {
                    menu: menu,
                    dynamicMenuRoutes: _vm.dynamicMenuRoutes,
                  },
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }